import { Button } from '@/components/ui/button';
import { t, getLocale } from '@/i18n';
import { csvNumber, csvSeparator, downloadCsv } from '@/lib/csv';
import { Download } from 'lucide-react';

// Local calendar date (history dates are local midnights stored as UTC ISO).
const localDate = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// KPIs per day, one row per working day of the chosen range.
export function kpiCsv(rows, locale) {
  return [
    [t('csv.date'), t('csv.pilot'), t('csv.planned'), t('stats.kpi.noShows'), `${t('stats.kpi.informed')} (%)`,
      t('stats.kpi.urgencies'), t('stats.series.auto'), t('stats.series.planner'), t('stats.kpi.parking')],
    ...rows.map(r => [
      localDate(r.date), r.pilot ? t('csv.yes') : t('csv.no'), r.planned, r.noShows, r.informedPct,
      r.urgencies, r.autoResolved, r.urgencies - r.autoResolved, r.parkingTrucks,
    ]),
  ].map(row => row.map(v => (typeof v === 'number' ? csvNumber(v, locale) : v)));
}

// Carrier scorecard of the chosen range, same columns as the table.
export function carriersCsv(scorecard, locale) {
  const keys = ['loadings', 'announcedPct', 'noShowPct', 'outOfHours', 'replyMedian', 'onTimePct'];
  const units = { announcedPct: ' (%)', noShowPct: ' (%)', replyMedian: ' (min)', onTimePct: ' (%)' };
  return [
    [t('stats.carrier.name'), t('csv.country'), ...keys.map(k => `${t(`stats.carrier.${k}`)}${units[k] || ''}`)],
    ...scorecard.map(({ carrier, now }) => [carrier.name, carrier.country, ...keys.map(k => csvNumber(now[k], locale))]),
  ];
}

// Downloads `build(locale)` as `<name>-<days>d.csv`.
export const ExportCsvButton = ({ name, days, build }) => (
  <Button
    variant="outline"
    size="sm"
    className="gap-1"
    onClick={() => {
      const locale = getLocale();
      downloadCsv(`omya-${name}-${days}d.csv`, build(locale), csvSeparator(locale));
    }}
  >
    <Download className="h-4 w-4" /> {t('csv.export')}
  </Button>
);
